<img
  class="main-image"
  src="/assets/images/lifestyle/Romanescu Project Phases.jpg"
>

<div
  class="container"
>
  <p
    class="downtown-description"
    [innerHTML]="'pages.downtown_life.finishes.paragraph1' | translate"
  >
  </p>

  <p>
    <label class="title center">Prima fază</label>
  </p>
  <div
    fxLayout="row wrap"
    fxLayoutAlign="center center"
    class="downtown-description"
  >
    <div
      fxLayout="column"
      fxLayoutAlign="center center"
      *ngFor="let reason of reasons"
      class="lifestyle-item"
    >
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="icon-container gradient-background"
      >
        <img [src]="reason.image.url" alt="" class="icon">
      </div>
      <h3
        class="title"
      >
        {{ reason.title }}
      </h3>
    </div>
  </div>

  <p>
    <label class="title center">A doua fază</label>
  </p>
  <div
    fxLayout="row wrap"
    fxLayoutAlign="center center"
    class="downtown-description"
  >
    <div
      fxLayout="column"
      fxLayoutAlign="center center"
      *ngFor="let reason of reasons2"
      class="lifestyle-item"
    >
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="icon-container gradient-background"
      >
        <img [src]="reason.image.url" alt="" class="icon">
      </div>
      <h3
        class="title"
      >
        {{ reason.title }}
      </h3>
    </div>
  </div>

  <p>
    <label class="title center">A 3a fază</label>
  </p>
  <div
    fxLayout="row wrap"
    fxLayoutAlign="center center"
    class="downtown-description"
  >
    <div
      fxLayout="column"
      fxLayoutAlign="center center"
      *ngFor="let reason of reasons3"
      class="lifestyle-item"
    >
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="icon-container gradient-background"
      >
        <img [src]="reason.image.url" alt="" class="icon">
      </div>
      <h3
        class="title"
      >
        {{ reason.title }}
      </h3>
    </div>
  </div>

  <p
    class="downtown-description"
    [innerHTML]="'pages.downtown_life.finishes.paragraph2' | translate"
  >
  </p>
</div>



// WEBPACK FOOTER //
// ./src/app/downtown-life/finishes.component.html